<script setup lang="ts">
import UIKit from '@pocketprep/ui-kit'
import { RouterLink } from 'vue-router'
const { Link: PocketLink, Icon } = UIKit
</script>

<template>
    <header class="assignment-head">
        <slot name="left">
            <RouterLink
                v-slot="{ href, navigate }"
                custom
                :to="{ name: 'assignments' }"
            >
                <PocketLink
                    class="assignment-head__back-btn"
                    :isDarkMode="true"
                    :href="href"
                    @click="navigate"
                >
                    <Icon type="arrow" class="assignment-head__back-arrow"></Icon>
                    <span>Back to Assignments</span>
                </PocketLink>
            </RouterLink>
        </slot>
        <slot name="center"></slot>
        <slot name="right"></slot>
    </header>
</template>

<style lang="scss" scoped>
@use 'sass:color';

.assignment-head {
    height: 54px;
    width: 100%;
    background-color: $charcoal;
    display: flex;
    align-items: center;
    justify-content: space-between;
    position: fixed;
    z-index: 2;

    &__back-btn {
        font-weight: 600;
        margin-left: 44px;
    }

    &__back-arrow {
        transform: rotate(180deg);
        margin-right: 6px;
    }
}
</style>
